<template>
  <div class="content-edit">

    <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
      <div class="white-container">
        <p class="mb10">基础信息</p>
        <el-form-item label="页面标题" prop="pageTitle" style="width: 460px">
          <el-input v-model="form.pageTitle" maxlength="10" placeholder="请输入页面标题" />
        </el-form-item>
        <el-form-item label="活动标题" prop="campaignTitle" style="width: 460px">
          <el-input v-model="form.campaignTitle" placeholder="请输入活动标题" />
        </el-form-item>
        <el-form-item label="活动时间" prop="campaignTime" style="width: 460px">
          <el-date-picker
            v-model="form.campaignTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleReceiveTimeChange"
          />
        </el-form-item>
      </div>
      <template v-for="(item, index) in form.content">
        <UploadImg v-if="item.type === 'image'" :key="index" :index="index" :img-info="item.content" @uploadImg="handleUploadImgInfo" @del="delComponent" />
        <UploadVideo v-if="item.type === 'video'" :key="index" :index="index" :video-info="item.content" @uploadVideo="handleUploadVideoInfo" @del="delComponent" />
        <UploadSwiper v-if="item.type === 'carousel'" :key="index" :contents="item.contents" :index="index" @update="updateCarousel" @del="delComponent" />
      </template>
      <div class="white-container marginTop">
        <p class="mb10">配置选项</p>
        <div class="add-btn-box">
          <el-button class="add-btn" icon="el-icon-plus" @click="addComponent('image')">添加图片</el-button>
          <el-button class="add-btn" icon="el-icon-plus" @click="addComponent('video')">添加视频</el-button>
          <el-button class="add-btn" icon="el-icon-plus" @click="addComponent('carousel')">添加轮播图</el-button>
        </div>
      </div>
      <div class="white-container white-container-bottom marginTop">
        <p class="share-card"> <span class="red-star">*</span> 上传图片</p>
        <div class="flex uploadImg-cont">
          <el-form-item prop="shareCardPictures" style="margin-left: -130px;">
            <UploadImage :url="form.shareCardPictures" save-path="loyaltyCampaign/" size-tips="500px*400px" title="小程序分享卡片" @triggerReg="handleCheckReg" @upload="shareImageUpload" />
          </el-form-item>
        </div>
        <div class="share-title">
          <el-form-item label="分享标题" prop="shareCardTitle" style="margin-left: -60px;">
            <el-input v-model="form.shareCardTitle" placeholder="请输入分享标题" class="label-input" />
          </el-form-item>
        </div>
      </div>
      <div class="white-container marginTop submit-btn-box">
        <el-form-item style="width: 100%; margin-left: -50px;">
          <div class="flex btns">
            <el-button class="btn" type="info" @click="handleCancel">取消</el-button>
            <el-button class="btn" type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />

  </div>
</template>
<script>
import UploadImage from "@/components/UploadImage";
import UploadImg from "../component/uploadImg.vue";
import UploadVideo from "../component/uploadVideo.vue";
import UploadSwiper from "../component/uploadSwiper.vue";
import Dialog from "@/components/Dialog";
export default {
  components: { UploadImage, Dialog, UploadImg, UploadVideo, UploadSwiper },

  data() {
    return {
      previewId: null,
      form: {
        shareCardPictures: '',
        pageTitle: '',
        campaignTitle: '',
        campaignTime: '',
        content: [],
        shareCardTitle: '',
      },
      formDialogShow: false,
      information: {},
      rules: {
        pageTitle: [
          { required: true, message: "请输入页面标题", trigger: ["blur"] },
        ],
        campaignTitle: [
          { required: true, message: "请输入活动标题", trigger: ["blur"] },
        ],
        shareCardPictures: [
          { required: true, message: "请上传分享图片", trigger: ["blur"] },
        ],
      },
    };
  },
  async created() {
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.form.id = query.id;
      this.handleType = "edit";
      this.fetchMarketContent();
    } else if (query.copyid) {
      this.form.id = query.copyid;
      this.handleType = "copy";
      this.fetchMarketContent();
    } else {
      this.handleType = 'add';
    }
  },
  beforeDestroy() { },
  methods: {
    submit() {
      this.$refs.form.validate().then(res => {
        if (res) {
          if (this.form.content.length === 0) {
            this.$message.error('请先添加活动内容');
            return;
          }
          this.formDialogShow = true;
          this.information = {
            operation: "submit",
            icon: "warn",
            subTitle: "是否确认保存编辑的内容？",
          };
        }
      });
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("shareCardPictures");
    },
    async fetchMarketContent() {
      this.$Api.loyaltyCampaign.activityInfo(this.form.id).then(res => {
        if (res.startTime && res.endTime) {
          res.campaignTime = [new Date(res.startTime), new Date(res.endTime)];
        }
        res.shareCardTitle = res.shareCardTitle || '';
        this.form = Object.assign(this.form, res);
        if (this.handleType === 'copy') {
          delete this.form.id;
        }
      });
    },
    // 新增活动
    addContent() {
      this.form?.id && delete this.form.id;
      this.form.campaignTime && delete this.form.campaignTime;
      this.$Api.loyaltyCampaign.addActivity(this.form).then(() => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        // this.$router.go(-1);
      });
    },
    // 编辑活动
    editActivity() {
      this.form.campaignTime && delete this.form.campaignTime;
      this.$Api.loyaltyCampaign.editActivity(this.form).then(() => {
        this.$message.success("编辑成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '编辑失败');
        this.$router.go(-1);
      });
    },
    // 更新接口
    updateContent() {
      this.$Api.content.updateMarketContent(this.form).then(() => {
        this.$message.success("编辑成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        this.$router.go(-1);
      });
    },
    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃本次更改，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        if (this.handleType === 'edit') {
          this.editActivity();
        } else {
          this.addContent();
        }
      }
    },

    addComponent(type) {
      let itemObj = {
        type,
        content: { sourceUrl: '', jumpLink: '', sensorsData: { btnName: '', moduleName: '' }, subscribeId: '' },
      };
      if (type === 'video') {
        itemObj.content.cloudVideoId = null;
        itemObj.content.coverImageUrl = '';
      }
      if (type === 'carousel') {
        itemObj = { type, contents: [] };
      }
      this.form.content.push(itemObj);
    },
    delComponent(index) {
      this.form.content.splice(index, 1);
    },
    handleUploadImgInfo(data) {
      this.form.content[data.index].content = data.imgInfo;
    },
    handleUploadVideoInfo(data) {
      this.form.content[data.index].content = data.videoInfo;
    },
    updateCarousel(data) {
      this.form.content[data.index].contents = data.contents;
    },
    shareImageUpload(data) {
      this.form.shareCardPictures = data;
    },
    handleReceiveTimeChange(value) {
      this.form.startTime = this.$moment(value[0]).format('YYYY-MM-DD HH:mm:ss');
      this.form.endTime = this.$moment(value[1]).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
<style lang="less" scoped>
.mb10{
  margin-bottom: 10px;
}
.content-edit {
  .add-btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:35px;
  }
  .add-btn{
    width: 150px;
    height: 34px;
    border: 1px dashed #9B9B9B;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .upload-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 222px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 30px 44px;
    background: #f7f7f7;
    .upload-box-left{
      display: flex;
      align-items: center;
      gap: 60px;
    }
    .upload-img-tips{
      font-size: 12px;
      color: #bbb;
      margin-top: 5px;
      line-height: 1.2;
    }

    .label-delete{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin-right: 100px;
    }
    .change-img{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin: 10px 0;
    }
    .img-ele{
      width: 210px;
      height: 150px;
      border-radius: 4px;
      object-fit: cover;
    }
    .change-img-tips-box{
      display: flex;
      align-items: center;
      margin-top: 6px;
      .change-img-txt-box{
        position: relative;
        color: #0085D0;
        cursor: pointer;
        margin-right: 15px;
        .upload-img-input{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
        }
        .change-img-btn{
          width: 110px;
          height: 38px;
        }
      }
    }
  }
  .share-card{
    margin-bottom: 20px;
    .red-star{
      color: #F56C6C;
    }
  }
  .share-title{
    width: 430px;
    margin-top: -10px;
    padding-bottom: 2px;
  }
  .submit-btn-box{
    padding-bottom: 1px;
  }
  .btns {
    align-items: center;
    justify-content: center;
    .btn{
      width: 120px;
      height: 40px;
    }
  }
  .marginTop {
    margin-top: 30px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .white-container-bottom {
    padding-bottom: 0;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
